<template>
    <div>
        <button
            class="flex items-center justify-between w-full px-6 py-4 font-semibold text-left text-sm text-gray-500 border-t border-gray-200 hover:bg-gray-100"
            :class="active ? 'bg-gray-50' : 'bg-white'"
            type="button"
            @click="toggleActive()"
        >
            <span class="text-black">{{ title }}</span>
            <icon :name="active ? 'arrow-drop-up-line' : 'arrow-drop-down-line'" size="34"></icon>
        </button>
        <div v-show="active">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
    name: 'live-designer-accordion',
    props: {
        title: {
            type: String,
            required: true
        },
        extended: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            active: this.isExtendedInCookie() || this.extended,
        };
    },
    methods: {
        toggleActive () {
            this.active = !this.active;
            this.setPropertyCookie(this.getUpdatedCookieValue());
        },
        getUpdatedCookieValue () {
            let cookieValue = this.getPropertyCookie();

            cookieValue['accordions'] = cookieValue['accordions'] || {};
            cookieValue['accordions'][this.title] = cookieValue['accordions'][this.title] || {};
            cookieValue['accordions'][this.title]['extended'] = this.active;

            return cookieValue;
        },
        isExtendedInCookie () {
            return this.getPropertyCookie()?.accordions?.[this.title]?.extended ?? false;
        },
        setPropertyCookie (cookieValue) {
            Cookies.set('designer_state', cookieValue, {expires: 1, domain: location.hostname});
        },
        getPropertyCookie () {
            let cookie = Cookies.get('designer_state');
            return cookie ? JSON.parse(cookie) : {};
        },
    }
}
</script>
